import { Injectable } from '@angular/core';

import { APIURLConstantsService } from '../../services/api-url-service/apiurlconstants.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable()
export class ReportsService {

  private options: {
    headers?: HttpHeaders,
    observe?: 'body',
    params?: HttpParams,
    reportProgress?: boolean,
    responseType: any,
    withCredentials?: boolean
  };

 public getAnys(): Observable<any> {
  return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + "reportAnys/")
    .pipe(map(response => response || []));
 }

 public getReport(quin: number, data: string, exportar = false): Observable<any> {
  let params = new HttpParams();
    params = params.append('export', exportar.toString());
    params = params.append('year', data);

  return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + "report/"+quin, this.options)
    .pipe(map(response => response || []));
 }

 constructor(private authHttp: HttpClient) {}
}
